$ = require 'jquery'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
Auth = require 'app/scripts/db/auth'
template = require 'app/scripts/views/templates/header_enterprise_notification'
Util = require 'app/scripts/lib/util'

module.exports = class EnterpriseNotificationBannerView extends WarningBannerView
  className: Util.extendParentClassName('enterprise-notification-banner')

  events:
    'click .js-dismiss-enterprise-notification-banner': 'dismiss'

  render: ->
    data =
      enterpriseName: @model.displayName
      message: @model.message

    @$el.html template(data)

    @

  dismiss: (e) ->
    Auth.me().dismiss("enterprise-notification-banner-#{ @model.id }")
    $(e.target).closest('.enterprise-notification-banner').remove()
    e.preventDefault()
